import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store/reducers';

// Member interface
interface Member {
  memberId: string;
  name: string;
  // Add other required member properties
}

interface MemberNavigationState {
  membersList: Member[];
  currentMemberIndex: number;
}

const initialState: MemberNavigationState = {
  membersList: [],
  currentMemberIndex: -1
};

export const memberNavigationSlice = createSlice({
  name: 'memberNavigation',
  initialState,
  reducers: {
    setMembersList: (state, { payload }: PayloadAction<Member[]>) => {
      state.membersList = payload;
    },

    setCurrentMemberIndex: (state, { payload }: PayloadAction<number>) => {
      state.currentMemberIndex = payload;
    },

    navigateToNextMember: state => {
      if (state.currentMemberIndex < state.membersList.length - 1) {
        state.currentMemberIndex += 1;
      }
    },

    navigateToPreviousMember: state => {
      if (state.currentMemberIndex > 0) {
        state.currentMemberIndex -= 1;
      }
    },

    resetMemberNavigation: state => {
      state.currentMemberIndex = -1;
      state.membersList = [];
    }
  }
});

export const {
  setMembersList,
  setCurrentMemberIndex,
  navigateToNextMember,
  navigateToPreviousMember,
  resetMemberNavigation
} = memberNavigationSlice.actions;

// Selectors
export const selectMembersList = (state: RootState) => state.rootReducer.memberNavigation.membersList;

export const selectCurrentMemberIndex = (state: RootState) => state.rootReducer.memberNavigation.currentMemberIndex;

export const selectCurrentMember = (state: RootState) => {
  const { membersList, currentMemberIndex } = state.rootReducer.memberNavigation;
  return currentMemberIndex >= 0 && membersList.length > currentMemberIndex ? membersList[currentMemberIndex] : null;
};

export const selectHasNextMember = (state: RootState) =>
  state.rootReducer.memberNavigation.currentMemberIndex < state.rootReducer.memberNavigation.membersList.length - 1;

export const selectHasPreviousMember = (state: RootState) => state.rootReducer.memberNavigation.currentMemberIndex > 0;

export default memberNavigationSlice.reducer;
